/**
 * Dark-mode counterparts of the ramps in `colors.ts`. Each step keeps its role rather than its value: `50` is
 * still the faintest tint of the hue over the page and `900` its strongest ink, so a `green.50` fill under a
 * `green.700` label reads the same way on a dark page as on a light one.
 */

export const darkInk = '#EDEDED';

export const darkOnColor = '#121212';

export const darkSurface = {
    default: '#121212',
    paper: '#1A1A1A',
};

export const darkText = {
    secondary: '#ABABAB',
    disabled: '#6A6A6A',
};

export const darkPurple = {
    50: '#221624',
    100: '#2E1C31',
    200: '#462A4A',
    300: '#653D6A',
    400: '#8F5C95',
    500: '#B985BE',
    600: '#C79BCB',
    700: '#D5B2D8',
    800: '#E4CCE6',
    900: '#F2E6F3',
};

export const darkRed = {
    50: '#2A1617',
    100: '#3A1C1E',
    200: '#5A2629',
    300: '#84343A',
    400: '#C2525A',
    500: '#F07D83',
    600: '#F49499',
    700: '#F7ABAF',
    800: '#FAC6C9',
    900: '#FDE3E4',
};

export const darkOrange = {
    50: '#2A1C12',
    100: '#3A2618',
    200: '#573822',
    300: '#7E5131',
    400: '#B9744A',
    500: '#F2A06E',
    600: '#F5B28A',
    700: '#F8C4A5',
    800: '#FBD8C3',
    900: '#FDEBE0',
};

export const darkGreen = {
    50: '#0F231D',
    100: '#143128',
    200: '#1D4A3D',
    300: '#286A57',
    400: '#38967B',
    500: '#4FBF9E',
    600: '#6FCDB1',
    700: '#93DAC4',
    800: '#B8E7D8',
    900: '#DDF3EC',
};

export const darkGrey = {
    50: '#242424',
    100: '#2E2E2E',
    200: '#3D3D3D',
    300: '#555555',
    400: '#6E6E6E',
    500: '#8A8A8A',
    600: '#A3A3A3',
    700: '#BDBDBD',
    800: '#D6D6D6',
    900: '#EDEDED',
};

export const darkCement = {
    50: '#1F1D1A',
    100: '#272420',
    200: '#36312B',
    300: '#443E37',
    400: '#5A534A',
    500: '#7D746A',
    600: '#A0978C',
    700: '#C2BAAF',
    800: '#DDD7CD',
    900: '#F2EFE8',
};
